import createIcon from '../../createIcon';

/**
 * @component @name HPlusMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTFINVY3SDNWMTdINVYxM0gxMVYxN0gxM1Y3SDExVjExWk0yMSAxMUgxOVY5SDE3VjExSDE1VjEzSDE3VjE1SDE5VjEzSDIxVjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HPlusMobiledata = createIcon('HPlusMobiledata', [
  [
    'path',
    {
      d: 'M11 11H5V7H3V17H5V13H11V17H13V7H11V11ZM21 11H19V9H17V11H15V13H17V15H19V13H21V11Z',
      key: '1h7b6j',
    },
  ],
]);

export default HPlusMobiledata;
